import React from "react";
import { CellContext } from "@tanstack/react-table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";

export const StatusCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue()
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (status: string) => {
        setValue(status);
        table.options.meta?.updateData(index, id, status)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    let style = "bg-chart-green";
    if (value === "Open") {
        style = "bg-chart-amber";
    } else if (value === "Cancelled") {
        style = "bg-gray-500";
    }

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button className={`w-full ${style} text-white border-none focus:ring-0 rounded-none`}>
                        {value as string}
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="center" className="p-0 rounded-none">
                    <DropdownMenuItem
                        key={id + "_status_open"}
                        className="bg-chart-amber rounded-none"
                        onClick={() => {
                            // Add logic to update status to Open
                            onBlur("Open");
                        }}
                    >
                        <div className="w-full text-center">Open</div>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        key={id + "_status_closed"}
                        className="bg-chart-green rounded-none"
                        onClick={() => {
                            // Add logic to update status to Closed
                            onBlur("Closed");
                        }}
                    >
                        <div className="w-full text-center">Closed</div>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        key={id + "_status_cancelled"}
                        className="bg-gray-500 text-white rounded-none"
                        onClick={() => {
                            // Add logic to update status to Cancelled
                            onBlur("Cancelled");
                        }}
                    >
                        <div className="w-full text-center">Cancelled</div>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        );
    }
    return <div className={"text-center text-white " + style}>{value as string}</div>
};